import {Nullish} from 'shared/web';

export type OptionTypeBase<T> = {
  value?: T;
  label?: string | Nullish;
  fieldLabel?: string | null;
  isDisabled?: boolean;
};
